import PropTypes from 'prop-types'
import { LinearProgress } from '@mui/material'
import { metricDataPropType } from '../Utils/types'

export default function ProgressMetric({ data, colour, height = 5 }) {
  const percentage =
    data.target > 0 ? Math.round((data.value / data.target) * 100) : 0

  return (
    <LinearProgress
      variant="determinate"
      value={Math.min(percentage, 100)}
      sx={{
        width: '100%',
        height,
        borderRadius: 10,
        backgroundColor: `${colour}22`,
        '& .MuiLinearProgress-bar': {
          backgroundColor: colour,
          borderRadius: 10,
        },
      }}
    />
  )
}

ProgressMetric.propTypes = {
  label: PropTypes.string.isRequired,
  colour: PropTypes.string.isRequired,
  height: PropTypes.number,
  data: metricDataPropType.isRequired,
}
